import angular from 'angular';
import uiRouter from 'angular-ui-router';
import bookingComponent from './booking.component';
import cacheService from '../../../services/cache.service';
import view from './view/view';
import myBookingApi from '../../../api/mybooking/mybooking';

const BookingModule = angular.module('onTheBeachBooking', [
    uiRouter,
    cacheService,
    myBookingApi,
    view
])
    .config(($stateProvider, $urlRouterProvider) => {
        'ngInject';
        $stateProvider
            .state('onTheBeach.booking', {
                resolve: {
                    data: function ($q, myBookingService, cacheService, authService, $state) {
                        'ngInject';
                        let agencyBookingReference = cacheService.get('agencyBookingReference');
                        if (agencyBookingReference) {
                            return myBookingService.getGlobalInfoBooking(agencyBookingReference, true).then(booking => {
                                return booking;
                            }, function (error) {
                                if (error.status === 401 || error.status === 403) {
                                    authService.clearSession();
                                    $state.go('onTheBeach.login');
                                }
                                return $q.reject(error);
                            });
                        } else {
                            $state.go('onTheBeach.login');
                            return $q.reject('No booking reference');
                        }
                    }
                },                            
                url: '/booking',
                abstract: true,
                redirectTo: 'onTheBeach.booking.view',
                views: {
                    'main@': {
                        template: '<on-the-beach-booking data="$resolve.data"></on-the-beach-booking>'
                    }
                }
            });
    })
    .component('onTheBeachBooking', bookingComponent)
    .name;

export default BookingModule;



// WEBPACK FOOTER //
// ./client/app/routes/onTheBeach/booking/booking.js